import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from '@chakra-ui/react';
import Accommodations from '../Accomodations/Accommodations';
import Buses from '../Buses/Buses';
import Cars from '../Cars/Cars';
import Flights from '../Flights/Flights';


const MyTravelManager = () => {
    return (
        <Box>
            <Tabs variant="enclosed">
                <TabList mb="1em" justifyContent="flex-start">
                    {["Flights", "Cars", "Buses", "Accommodations"].map((label) => (
                        <Tab
                            key={label}
                            px={4}
                            py={2}
                            bg="white"
                            _selected={{ bg: "teal.500", color: "white" }}
                        >
                            {label}
                        </Tab>
                    ))}
                </TabList>

                <TabPanels>
                    <TabPanel p={0}><Flights /></TabPanel>
                    <TabPanel p={0}><Cars /></TabPanel>
                    <TabPanel p={0}><Buses /></TabPanel>
                    <TabPanel p={0}><Accommodations /></TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default MyTravelManager;